import React from 'react'

// styles

import { Text } from '@/components/commons/typography/Text'
import { skeleton } from '@/components/skeleton/styles/index.css'
import { cssClass } from '@/shared/utils'
import Image, { ImageProps } from 'next/image'
import Link from 'next/link'

export interface AvatarProps extends Partial<ImageProps> {
  image: string
  username?: string
  size?: number
  isLoading?: boolean
  isHiring?: boolean
  unoptimized?: boolean
  to?: string
  containerClassName?: string
  imageFit?: 'cover' | 'contain'
  custonBorderRadius?: number | string
}

interface AvatarLinkProps {
  to?: string
  children: React.ReactNode
}

const AvatarLink = ({ to, children }: AvatarLinkProps) => {
  if (!to) return <>{children}</>

  return <Link href={to}>{children}</Link>
}

export const Avatar: React.FC<AvatarProps> = ({
  image,
  username,
  size = 144,
  alt = 'avatar',
  className = '',
  onClick,
  isLoading = false,
  isHiring = false,
  unoptimized = false,
  containerClassName = '',
  custonBorderRadius,
  to,
  imageFit = 'cover',
}) => {
  const defaultAvatar = '/assets/avatar.png'
  const srcImage = image ? image : defaultAvatar
  const alternativeText = alt ? alt : username ? username : ''

  const borderRadius = React.useMemo(() => {
    if (custonBorderRadius) {
      return custonBorderRadius
    }

    if (typeof size === 'string') {
      return 12
    }

    if (size < 40) {
      return 8
    } else if (size < 45) {
      return 10
    } else if (size < 80) {
      return 12
    } else {
      return 20
    }
  }, [size, custonBorderRadius])

  return (
    <div
      style={{
        width: size,
        aspectRatio: '1/1',
        borderRadius,
        overflow: 'hidden',
      }}
      className={cssClass(['relative', skeleton, containerClassName])}
    >
      {!isLoading && (
        <AvatarLink to={to}>
          <Image
            key={`${srcImage}-${alternativeText}`}
            src={srcImage}
            alt={`${alternativeText} avatar`}
            width={size}
            height={size}
            style={{
              objectFit: imageFit,
            }}
            sizes={`${size + 20}px`}
            onClick={onClick}
            className={className}
            unoptimized={unoptimized}
          />
        </AvatarLink>
      )}
      {isHiring && (
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 80.67%)',
          }}
          className="absolute full-w z-10 bottom-0 flex items-center justify-center rounded-b-12"
        >
          <Text
            colorClass="cl-white-primary"
            sizeClass="text-10 text-12--tablet"
          >
            🤝 HIRING
          </Text>
        </div>
      )}
    </div>
  )
}
